import React from 'react'

const ArrowDownIcon = props => (
  <svg
    fill="white"
    height={24}
    width={24}
    {...props}
  >
    <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" />
  </svg>
)

export default ArrowDownIcon



// WEBPACK FOOTER //
// ./src/components/ArrowDownIcon.js